import React from 'react'
import Modal from 'react-modal';
import {locale} from '../locale/AppLocale'

import {connect} from 'react-redux'

import axios from 'axios'
import Config from '../Helpers/Config'
import {NotificationManager} from '../Helpers/NotificationManager';
import {validatePhone} from '../Helpers/validatePhone'
import {check,requiresRelogin} from '../actions/authActions'
import Loader from '../Components/Loader'

const customStyles = {
    overlay: {
        backgroundColor: 'none'
    },
    content: {
        overflow: '',
        top: '',
        left: '',
        right: '',
        bottom: '',
        marginRight: '',
        transform: '',
        padding: '',
        border: '',
        background: '',
        borderRadius: '',
    }
};

class MobileUpdate extends React.Component {

    constructor(props) {
        super(props);
        let isOpen = props.opened || false;
        this.state = {
            modalIsOpen: isOpen,
            mobile_number: '',
            updating: false
        };

        this.closeModal = this.closeModal.bind(this);

        this.save = this.save.bind(this);

    }


    closeModal(proxy) {
        this.setState({modalIsOpen: false});
    }

    render() {
        return (
            <div>
                <Modal
                    portalClassName={'shooq-modal'}
                    isOpen={this.state.modalIsOpen}
                    onRequestClose={this.closeModal}
                    style={customStyles}
                    contentLabel={locale.get('mobile_update_title')}
                    shouldCloseOnOverlayClick={false}
                >
                    <div className="shooq-modal--box">
                        <div className="shooq-modal--header">
                            <div className="shooq-modal--header--title">{locale.get('mobile_update_title')}</div>
                        </div>
                        <div className="clearfix"></div>
                        <div className="shooq-modal--body">
                            <p>{locale.get('mobile_update_required')}</p>
                            <input
                                onChange={(e) => this.setState({mobile_number: e.target.value})}
                                type="text"
                                className="input"
                                placeholder={locale.get('mobile_number')}/>
                        </div>
                        <div className="clearfix"></div>
                        <div className="shooq-modal--footer">
                            <button className="btn-1" onClick={this.save} disabled={this.state.updating}>
                                <Loader completed={this.state.updating === false}/> {locale.get('save')}
                            </button>
                        </div>
                    </div>
                </Modal>
            </div>
        );
    }


    save() {

        if (!this.state.mobile_number) {
            NotificationManager.error(locale.get('mobile_is_required'))
            return;
        }

        if (!validatePhone(this.state.mobile_number)) {
            NotificationManager.error(locale.get('mobile_is_invalid'))
            return;
        }

        let data = new FormData();

        this.setState({
            updating: true
        });

        data.append('mobile', this.state.mobile_number)
        data.append(this.props.auth.user.token_key, this.props.auth.user.token_value)

        axios.post(Config.mainUrl('user/ajax/update-mobile'), data,
            {
                withCredentials: Config.withCredentials(),
                headers: {'X-Requested-With': 'XMLHttpRequest'}
            }).then((response) => {
            NotificationManager.success(response.data.message)
            NotificationManager.warning(locale.get('mobile_require_activation'))
            this.props.checkAuth();
            this.setState({updating: false})

        }).catch((error) => {
            if(error.response.status === 401) {
                this.props.requiresReLogin();
            }else{
                if (error && error.response && error.response.data) {
                    NotificationManager.error(error.response.data.message)
                }
            }
            this.setState({updating: false})
        })
    }
}


// Maps state from store to props
const mapStateToProps = (state, ownProps) => {
    return {
        auth: state.auth
    }
};


// Maps actions to props
const mapDispatchToProps = (dispatch) => ({
    checkAuth: () => dispatch(check()),
    requiresReLogin: ()=>dispatch(requiresRelogin(true,true))
});
export default connect(mapStateToProps, mapDispatchToProps)(MobileUpdate);
